import { template } from 'lodash';
import nfc from './assets/nfc.png';





// Useful shape metadata.

export const tagSizesPx = {
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDcxODM0MA==": {
    width: "472px",
    height: "472px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODAwMDkwMA==": {
    width: "472px",
    height: "472px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODUyNTE4OA==": {
    width: "472px",
    height: "472px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY1ODU0OA==": {
    width: "472px",
    height: "472px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2Nzk2ODEzMg==": {
    width: "354px",
    height: "354px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDY1MjgwNA==": {
    width: "354px",
    height: "354px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ5MjQyMA==": {
    width: "354px",
    height: "354px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY5MTMxNg==": {
    width: "354px",
    height: "354px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ1OTY1Mg==": {
    width: "236px",
    height: "236px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NzkzNTM2NA==": {
    width: "236px",
    height: "236px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDYyMDAzNg==": {
    width: "236px",
    height: "236px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzYyNTc4MA==": {
    width: "236px",
    height: "236px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc5ODU4MA==": {
    width: "472px",
    height: "472px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc2NTgxMg==": {
    width: "354px",
    height: "354px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTczMzA0NA==": {
    width: "236px",
    height: "236px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA3NjUzMg==": {
    width: "472px",
    height: "472px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA0Mzc2NA==": {
    width: "354px",
    height: "354px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzAxMDk5Ng==": {
    width: "236px",
    height: "236px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NjQ2MDgwNA==": {
    width: "649px",
    height: "649px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MTc2NDUzMg==": {
    width: "649px",
    height: "649px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NTkzNjUxNg==": {
    width: "649px",
    height: "649px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MjA1OTQ0NA==": {
    width: "649px",
    height: "649px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDA5NTc0OA==": {
    width: "649px",
    height: "649px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQ1MjY3NDEwMA==": {
    width: "649px",
    height: "649px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUwMTY2MjI2MA==": {
    width: "1016px",
    height: "638px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNzE4Mjc3Mg==": {
    width: "1016px",
    height: "638px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzODM5NTE4OA==": {
    width: "1016px",
    height: "638px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MjQ5MDExNg==": {
    width: "1016px",
    height: "638px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzgwMDgzNg==": {
    width: "1016px",
    height: "638px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MTkwMDI5Mg==": {
    width: "1016px",
    height: "638px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzExMjcwOA==": {
    width: "638px",
    height: "1016px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNDY5MjQwNA==": {
    width: "638px",
    height: "1016px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MDE5NjM1Ng==": {
    width: "638px",
    height: "1016px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODg4NTYzNg==": {
    width: "638px",
    height: "1016px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTAxNjYyOA==": {
    width: "638px",
    height: "1016px",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTYwNjQ1Mg==": {
    width: "638px",
    height: "1016px",
  },
};

export const tagSizes = {
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODAwMDkwMA==": {
    width: "40mm",
    height: "40mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODUyNTE4OA==": {
    width: "40mm",
    height: "40mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY1ODU0OA==": {
    width: "40mm",
    height: "40mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2Nzk2ODEzMg==": {
    width: "30mm",
    height: "30mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ5MjQyMA==": {
    width: "30mm",
    height: "30mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY5MTMxNg==": {
    width: "30mm",
    height: "30mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzYyNTc4MA==": {
    width: "20mm",
    height: "20mm",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDYyMDAzNg==": {
    width: "20mm",
    height: "20mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ1OTY1Mg==": {
    width: "20mm",
    height: "20mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NzkzNTM2NA==": {
    width: "20mm",
    height: "20mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc5ODU4MA==": {
    width: "20mm",
    height: "20mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDY1MjgwNA==": {
    width: "30mm",
    height: "30mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc2NTgxMg==": {
    width: "30mm",
    height: "30mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDcxODM0MA==": {
    width: "40mm",
    height: "40mm",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTczMzA0NA==": {
    width: "40mm",
    height: "40mm",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA3NjUzMg==": {
    width: "20mm",
    height: "20mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA0Mzc2NA==": {
    width: "30mm",
    height: "30mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzAxMDk5Ng==": {
    width: "40mm",
    height: "40mm",
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NjQ2MDgwNA==": {
    width: "55mm",
    height: "55mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NTkzNjUxNg==": {
    width: "55mm",
    height: "55mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDA5NTc0OA==": {
    width: "55mm",
    height: "55mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MTc2NDUzMg==": {
    width: "55mm",
    height: "55mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MjA1OTQ0NA==": {
    width: "55mm",
    height: "55mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQ1MjY3NDEwMA==": {
    width: "55mm",
    height: "55mm"
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUwMTY2MjI2MA==": {
    width: '86mm',
    height: '54mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MjQ5MDExNg==": {
    width: '86mm',
    height: '54mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MTkwMDI5Mg==": {
    width: '86mm',
    height: '54mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzgwMDgzNg==": {
    width: '86mm',
    height: '54mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNzE4Mjc3Mg==": {
    width: '86mm',
    height: '54mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzODM5NTE4OA==": {
    width: '86mm',
    height: '54mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MDE5NjM1Ng==": {
    width: '54mm',
    height: '86mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODg4NTYzNg==": {
    width: '54mm',
    height: '86mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzExMjcwOA==": {
    width: '54mm',
    height: '86mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNDY5MjQwNA==": {
    width: '54mm',
    height: '86mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTAxNjYyOA==": {
    width: '54mm',
    height: '86mm',
  },
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTYwNjQ1Mg==": {
    width: '54mm',
    height: '86mm',
  },
};

export const tagShapes = {
  // round
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY1ODU0OA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY5MTMxNg==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzYyNTc4MA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc5ODU4MA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc2NTgxMg==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTczMzA0NA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA3NjUzMg==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA0Mzc2NA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzAxMDk5Ng==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NzkzNTM2NA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2Nzk2ODEzMg==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODAwMDkwMA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ1OTY1Mg==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ5MjQyMA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODUyNTE4OA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDYyMDAzNg==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDY1MjgwNA==": "round",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDcxODM0MA==": "round",
  
  // square
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MTc2NDUzMg==": "square",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MjA1OTQ0NA==": "square",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NjQ2MDgwNA==": "square",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQ1MjY3NDEwMA==": "square",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NTkzNjUxNg==": "square",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDA5NTc0OA==": "square",
  
  // rectangle H
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUwMTY2MjI2MA==": "rectH",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNzE4Mjc3Mg==": "rectH",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzODM5NTE4OA==": "rectH",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MTkwMDI5Mg==": "rectH",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MjQ5MDExNg==": "rectH",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzgwMDgzNg==": "rectH",
  
  // rectangle V
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNDY5MjQwNA==": "rectV",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTAxNjYyOA==": "rectV",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTYwNjQ1Mg==": "rectV",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODg4NTYzNg==": "rectV",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MDE5NjM1Ng==": "rectV",
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzExMjcwOA==": "rectV",
};




// Lodash tag templates.

export const baseTpl = {
  background: "#ffffff",
  logo: "",
  logoWidth: 50,
  message: "",
  fontSize: 54,
  color: "#424242",
};

const roundTpl = template(`
  <div style="position:relative; width:100%; height:100%; border-radius:50%; background:<%= background %>; background-position:center; background-size:cover; display:flex; flex-direction:column; align-items:center; justify-content:center">
    <% if(logo) { %>
      <img src="<%= logo %>" width="<%= logoWidth %>%"/>
    <% } %>
    <% if(message) { %>
      <div>
        <p style="text-align:center; font-size:<%= fontSize %>px; color:<%= color %>; font-weight:bold; font-family:sans-serif; padding:0 16px; margin:0;">
          <%= message %>
        </p>
      </div>
    <% } %>
    <div style="position:absolute; bottom:0; width:100%; text-align:center;">
      <img src="${nfc}" style="width:20%; max-width:40px;"/>
    </div>
  </div>
`);
const squareTpl = template(`
  <div style="position:relative; width:100%; height:100%; background:<%= background %>; background-position:center; background-size:cover; display:flex; flex-direction:column; align-items:center; justify-content:center">
    <% if(logo) { %>
      <img src="<%= logo %>" width="<%= logoWidth %>%"/>
    <% } %>
    <% if(message) { %>
      <div>
        <p style="text-align:center; font-size:<%= fontSize %>px; color:<%= color %>; font-weight:bold; font-family:sans-serif; padding:0 16px; margin:0;">
          <%= message %>
        </p>
      </div>
    <% } %>
    <div style="position:absolute; bottom:0; width:100%; text-align:center;">
      <img src="${nfc}" style="width:20%; max-width:40px;"/>
    </div>
  </div>
`);
const rectHTpl = template(`
  <div style="position:relative; width:100%; height:100%; background:<%= background %>; background-position:center; background-size:cover; display:flex; flex-direction:column; align-items:center; justify-content:center">
    <% if(logo) { %>
      <img src="<%= logo %>" width="<%= logoWidth %>%"/>
    <% } %>
    <% if(message) { %>
      <div>
        <p style="text-align:center; font-size:<%= fontSize %>px; color:<%= color %>; font-weight:bold; font-family:sans-serif; padding:0 16px; margin:0;">
          <%= message %>
        </p>
      </div>
    <% } %>
    <div style="position:absolute; bottom:0; width:100%; text-align:center;">
      <img src="${nfc}" style="width:20%; max-width:40px;"/>
    </div>
  </div>
`);
const rectVTpl = template(`
  <div style="position:relative; width:100%; height:100%; background:<%= background %>; background-position:center; background-size:cover; display:flex; flex-direction:column; align-items:center; justify-content:center">
    <% if(logo) { %>
      <img src="<%= logo %>" width="<%= logoWidth %>%"/>
    <% } %>
    <% if(message) { %>
      <div>
        <p style="text-align:center; font-size:<%= fontSize %>px; color:<%= color %>; font-weight:bold; font-family:sans-serif; padding:0 16px; margin:0;">
          <%= message %>
        </p>
      </div>
    <% } %>
    <div style="position:absolute; bottom:0; width:100%; text-align:center;">
      <img src="${nfc}" style="width:20%; max-width:40px;"/>
    </div>
  </div>
`);

export const tagTemplates = {
  // round
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY1ODU0OA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY5MTMxNg==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzYyNTc4MA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc5ODU4MA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc2NTgxMg==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTczMzA0NA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA3NjUzMg==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA0Mzc2NA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzAxMDk5Ng==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NzkzNTM2NA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2Nzk2ODEzMg==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODAwMDkwMA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ1OTY1Mg==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ5MjQyMA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODUyNTE4OA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDYyMDAzNg==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDY1MjgwNA==": roundTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDcxODM0MA==": roundTpl,
  
  // square 
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MTc2NDUzMg==": squareTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MjA1OTQ0NA==": squareTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQ1MjY3NDEwMA==": squareTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NTkzNjUxNg==": squareTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NjQ2MDgwNA==": squareTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDA5NTc0OA==": squareTpl,
  
  // rectangle H
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUwMTY2MjI2MA==": rectHTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNzE4Mjc3Mg==": rectHTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzODM5NTE4OA==": rectHTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MTkwMDI5Mg==": rectHTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MjQ5MDExNg==": rectHTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzgwMDgzNg==": rectHTpl,
  
  // rectangle V
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNDY5MjQwNA==": rectVTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTAxNjYyOA==": rectVTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTYwNjQ1Mg==": rectVTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODg4NTYzNg==": rectVTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MDE5NjM1Ng==": rectVTpl,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzExMjcwOA==": rectVTpl,
};



// HTML and CSS templates for GrapesJS editor

const round = {
  css: `
    .tag-round {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 6% 0 0 0;
      background-position: center center;
      background-size: cover;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-radius: 50%;
      text-align: center;
    }
    .tag-round-image {
      width: 80%;
      height: 30%;
      object-fit: contain;
    }
    .tag-round-message {
      padding: 4%;
      font-family: sans-serif;
    }
  `,
  html: `
    <div class="tag-round">
      <svg width="40%" viewBox="0 0 166.09 55.15">
        <g>
          <g>
            <g>
              <path style="fill:currentcolor" d="M91.99,20.44c1.03,2.12,1.67,4.48,1.67,7c0,2.67-0.71,5.14-1.86,7.35l5.12,5.2c2.33-3.61,3.7-7.92,3.7-12.55
                c0-4.49-1.29-8.67-3.49-12.21L91.99,20.44z"/>
            </g>
            <g>
              <path style="fill:currentcolor" d="M102.13,10.13c3.41,4.9,5.44,10.86,5.44,17.31c0,6.59-2.12,12.66-5.67,17.62l4.96,5.04
                c4.78-6.28,7.66-14.13,7.66-22.66c0-8.4-2.79-16.12-7.43-22.35L102.13,10.13z"/>
            </g>
            <path style="fill:currentcolor" d="M112.07,0c5.89,7.53,9.42,17.06,9.42,27.39c0,10.51-3.64,20.15-9.68,27.72v0.04h54.27V0H112.07z"/>
          </g>
          <g>
            <g>
              <path style="fill:currentcolor" d="M0,6.98v5.17h11.17v30.56h6V12.15h11.2V6.98H0z"/>
              <path style="fill:currentcolor" d="M50.67,37.8c-0.22,0.18-0.47,0.36-0.87,0.36c-0.94,0-1.24-0.95-1.24-2.44V25.14
                c0-7.93-6.66-10.59-12.48-10.59c-4.66,0-8.4,1.71-11.31,4.58l3.42,3.27c1.89-1.86,4.26-3.16,7.35-3.16
                c3.71,0,7.24,1.93,7.24,5.89v1.53c-1.93-0.73-4.22-1.27-7.13-1.27c-6.66,0-12.08,2.8-12.08,8.91c0,5.93,5.17,9.06,10.73,9.06
                c3.56,0,6.91-1.31,9.24-3.56c0.69,2.26,2.47,3.56,4.91,3.56c1.34,0,2.51-0.36,3.24-0.95L50.67,37.8z M42.78,32.77
                c0,3.82-3.56,6.18-7.31,6.18c-3.06,0-6-1.53-6-4.66c0-2.98,2.66-4.84,6.95-4.84c2.62,0,4.95,0.73,6.37,1.27V32.77z"/>
              <path style="fill:currentcolor" d="M70.39,14.55c-3.82,0-7.02,1.6-9.42,4.04c-0.58-2.55-2.4-4.04-4.95-4.04c-1.53,0-2.62,0.4-3.38,0.95
                l1.06,4.62c0.22-0.15,0.47-0.33,0.87-0.33c1.02,0,1.24,0.95,1.24,2.4v28.77h5.89V40.01c2.25,2.04,5.24,3.35,8.69,3.35
                c8.22,0,13.75-6.37,13.75-14.4C84.14,20.95,78.61,14.55,70.39,14.55z M69.7,38.16c-4.77,0-8.55-3.2-8.55-9.2
                c0-5.97,3.78-9.17,8.55-9.17c5.02,0,8.44,4.11,8.44,9.17C78.13,34.08,74.71,38.16,69.7,38.16z"/>
            </g>
          </g>
        </g>
      </svg>
    
      <p class="tag-round-message-top">Add Message</p>
      <img src="" class="tag-round-image"/>
    
      <svg width="60%" viewBox="0 0 304.83 76.3" style="margin-bottom:2%">
        <g>
          <path style="fill:currentcolor" d="M7.09,24.64c-1.4-0.13-2.92-0.93-4.21-2.06c-3.42-2.97-3.89-6.45-0.89-9.89l5.17-5.94L4.92,4.81l2.81-3.23
            l2.23,1.94L13.02,0l4.2,3.65l-3.06,3.52l3.6,3.13l-2.81,3.23l-3.6-3.13l-5.12,5.89c-1.08,1.24-0.99,2.49,0.14,3.48
            c0.62,0.54,1.4,0.89,2.16,0.94L7.09,24.64z"/>
          <path style="fill:currentcolor" d="M30.12,29.27l-6.42,8.86l-4.21-3.05l1.4-1.93c-1.86,0.81-4.02,0.39-6.3-1.27c-3.64-2.64-4.34-6.22-2.39-8.91
            c1.99-2.74,5.3-3.25,10.03,0.18l3.58,2.59c1.4-1.93,1.06-3.9-1.36-5.65c-1.65-1.19-3.74-1.88-5.52-1.8l0.66-4.32
            c2.58,0.02,5.57,1.18,8.05,2.98C32.38,20.39,33.53,24.57,30.12,29.27z M22.75,29.96l1.15-1.59l-3.09-2.24
            c-2.11-1.53-3.33-1.23-4.09-0.19c-0.82,1.12-0.41,2.57,1.18,3.72C19.41,30.75,21.21,31,22.75,29.96z"/>
          <path style="fill:currentcolor" d="M52.19,43.8c-2.98,5.24-8.5,6.52-13.18,3.86c-2.08-1.18-3.41-2.8-3.87-4.87l-4.42,7.77l-4.83-2.75l12.9-22.68
            l4.62,2.62l-1.09,1.92c2.04-0.77,4.24-0.46,6.47,0.81C53.44,33.16,55.17,38.57,52.19,43.8z M47.29,41.02
            c1.64-2.88,0.8-5.66-1.62-7.03s-5.23-0.68-6.87,2.2c-1.64,2.88-0.8,5.66,1.62,7.03C42.84,44.59,45.65,43.9,47.29,41.02z"/>
          <path style="fill:currentcolor" d="M63.86,58.43c-1.38,0.28-3.07-0.05-4.63-0.75c-4.13-1.85-5.59-5.05-3.72-9.21l3.22-7.19l-2.7-1.21l1.75-3.9
            l2.7,1.21l1.91-4.26l5.07,2.27l-1.91,4.26l4.36,1.95l-1.75,3.9l-4.36-1.95l-3.19,7.12c-0.67,1.5-0.22,2.67,1.14,3.29
            c0.75,0.33,1.6,0.44,2.34,0.27L63.86,58.43z"/>
          <path style="fill:currentcolor" d="M74.04,42.75l5.21,1.95l-6.73,17.95l-5.21-1.95L74.04,42.75z M75.43,37.11c0.61-1.64,2.39-2.42,4.33-1.69
            c1.94,0.73,2.79,2.42,2.19,4.02c-0.65,1.73-2.43,2.52-4.36,1.79C75.65,40.5,74.82,38.74,75.43,37.11z"/>
          <path style="fill:currentcolor" d="M102.09,51.74L88.98,67.9l-5.51-1.6l-2.4-20.66l5.51,1.6l1.47,14.01l8.9-11L102.09,51.74z"/>
          <path style="fill:currentcolor" d="M118.52,63.07l-1.98,10.76l-5.12-0.94l0.43-2.35c-1.33,1.53-3.46,2.08-6.23,1.57
            c-4.42-0.81-6.59-3.75-5.99-7.01c0.61-3.33,3.39-5.21,9.13-4.15l4.35,0.8c0.43-2.35-0.72-3.97-3.66-4.51
            c-2-0.37-4.19-0.08-5.75,0.75l-1.26-4.18c2.34-1.09,5.54-1.34,8.55-0.78C116.73,54.08,119.57,57.36,118.52,63.07z M112.17,66.87
            l0.35-1.93l-3.75-0.69c-2.56-0.47-3.54,0.33-3.77,1.59c-0.25,1.37,0.74,2.49,2.66,2.85C109.49,69.02,111.22,68.47,112.17,66.87z"/>
          <path style="fill:currentcolor" d="M135.3,74.77c-1.21,0.71-2.92,0.95-4.62,0.79c-4.51-0.42-6.92-2.97-6.5-7.51l0.73-7.84l-2.95-0.27l0.4-4.26
            l2.95,0.27l0.43-4.65l5.54,0.51l-0.43,4.65l4.76,0.44l-0.4,4.26l-4.76-0.44l-0.72,7.77c-0.15,1.63,0.65,2.6,2.14,2.74
            c0.82,0.08,1.66-0.1,2.3-0.5L135.3,74.77z"/>
          <path style="fill:currentcolor" d="M157.78,68.05l-14.5-0.09c0.52,2.39,2.54,3.86,5.46,3.88c2.03,0.01,3.5-0.58,4.82-1.82l2.94,3.23
            c-1.79,2.02-4.47,3.07-7.93,3.05c-6.63-0.04-10.91-4.24-10.88-9.94c0.04-5.74,4.45-9.84,10.29-9.81c5.63,0.04,9.95,3.84,9.92,10
            C157.9,66.98,157.82,67.59,157.78,68.05z M143.23,64.72l9.44,0.06c-0.38-2.43-2.18-4-4.68-4.02
            C145.46,60.74,143.63,62.26,143.23,64.72z"/>
          <path style="fill:currentcolor" d="M175.12,73.71c-1.07,0.91-2.71,1.44-4.41,1.58c-4.51,0.37-7.33-1.72-7.7-6.27l-0.65-7.85l-2.95,0.24
            l-0.35-4.26l2.95-0.24l-0.38-4.65l5.54-0.46l0.38,4.65l4.76-0.39l0.35,4.26l-4.76,0.39l0.64,7.78c0.13,1.63,1.1,2.45,2.59,2.33
            c0.82-0.07,1.61-0.38,2.18-0.9L175.12,73.71z"/>
          <path style="fill:currentcolor" d="M194.52,60.46l1.86,10.78l-5.13,0.89l-0.41-2.35c-0.72,1.9-2.53,3.15-5.3,3.63c-4.43,0.77-7.48-1.24-8.05-4.51
            c-0.58-3.34,1.38-6.06,7.14-7.06l4.36-0.75c-0.41-2.35-2.05-3.48-5-2.97c-2,0.35-3.96,1.37-5.14,2.7l-2.63-3.49
            c1.82-1.83,4.73-3.17,7.75-3.69C189.74,52.64,193.53,54.73,194.52,60.46z M189.88,66.21l-0.33-1.93l-3.76,0.65
            c-2.56,0.44-3.21,1.53-2.99,2.79c0.24,1.37,1.55,2.08,3.49,1.75C188.11,69.16,189.54,68.05,189.88,66.21z"/>
          <path style="fill:currentcolor" d="M216.82,45.8l4.47,15.33c2,6.84-0.78,11.07-7.42,13.01c-3.49,1.02-7.13,1.15-9.77,0.1l1-4.45
            c1.94,0.81,4.75,0.88,7.11,0.19c3.76-1.1,4.91-3.29,3.94-6.61l-0.23-0.79c-0.95,1.95-2.75,3.29-5.15,3.99
            c-5.1,1.49-10.23-0.84-11.8-6.21c-1.57-5.37,1.51-10.09,6.61-11.58c2.57-0.75,4.94-0.51,6.86,0.86l-0.69-2.36L216.82,45.8z
             M214.06,55.96c-0.79-2.7-3.34-3.93-6.14-3.11c-2.81,0.82-4.33,3.23-3.54,5.93c0.79,2.7,3.37,3.92,6.18,3.1
            C213.36,61.06,214.85,58.66,214.06,55.96z"/>
          <path style="fill:currentcolor" d="M225.74,59.35c-0.74-1.93,0.21-3.74,2.01-4.43c1.8-0.69,3.71,0.03,4.45,1.96c0.73,1.9-0.18,3.81-1.98,4.5
            C228.42,62.06,226.47,61.24,225.74,59.35z"/>
          <path style="fill:currentcolor" d="M232.3,50.13c-2.45-5.23-0.15-10.83,5.5-13.47c3.65-1.71,7.26-1.47,9.85,0.78l-2.93,3.93
            c-1.71-1.21-3.44-1.3-5.02-0.56c-2.55,1.19-3.72,3.91-2.3,6.94c1.42,3.04,4.25,3.88,6.8,2.68c1.58-0.74,2.64-2.1,2.79-4.22l4.9,0.3
            c0.04,3.37-2.08,6.32-5.73,8.03C240.52,57.19,234.75,55.36,232.3,50.13z"/>
          <path style="fill:currentcolor" d="M251.69,40.98c-2.98-4.95-1.27-10.76,3.95-13.9c5.22-3.14,11.12-1.91,14.1,3.04
            c2.98,4.95,1.3,10.74-3.92,13.88C260.6,47.14,254.67,45.93,251.69,40.98z M264.91,33.02c-1.71-2.84-4.54-3.46-6.92-2.03
            c-2.38,1.43-3.18,4.25-1.48,7.09c1.71,2.84,4.57,3.45,6.95,2.01C265.85,38.66,266.62,35.86,264.91,33.02z"/>
          <path style="fill:currentcolor" d="M297.87,6.23l6.95,8.49l-4.3,3.52l-6.41-7.83c-1.96-2.4-3.94-2.62-5.68-1.2c-1.93,1.58-2.27,3.93-0.1,6.57
            l6.09,7.45l-4.3,3.52l-6.41-7.83c-1.96-2.4-3.89-2.67-5.68-1.2c-1.9,1.56-2.24,3.9-0.07,6.55l6.09,7.45l-4.3,3.52L267.62,20.4
            l4.11-3.36l1.4,1.71c0.06-2.17,1.18-4.19,3.08-5.74c2.07-1.69,4.49-2.34,6.87-1.57c-0.06-2.49,1.13-4.98,3.36-6.81
            C289.97,1.74,294.17,1.7,297.87,6.23z"/>
        </g>
      </svg>
    
    </div>
  `
};
const square = {
  css: `
    .tag-square {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 6% 0 0 0;
      background-color: #ffffff;
      background-position: center center;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      text-align: center;
    }
    .tag-square-image {
      width: 80%;
      height: 30%;
      object-fit: contain;
    }
    .tag-square-message {
      padding: 4%;
      font-family: sans-serif;
    }
  `,
  html: `
    <div class="tag-square">
      <svg width="40%" viewBox="0 0 166.09 55.15">
        <g>
          <g>
            <g>
              <path style="fill:current-color" d="M91.99,20.44c1.03,2.12,1.67,4.48,1.67,7c0,2.67-0.71,5.14-1.86,7.35l5.12,5.2c2.33-3.61,3.7-7.92,3.7-12.55
                c0-4.49-1.29-8.67-3.49-12.21L91.99,20.44z"/>
            </g>
            <g>
              <path style="fill:current-color" d="M102.13,10.13c3.41,4.9,5.44,10.86,5.44,17.31c0,6.59-2.12,12.66-5.67,17.62l4.96,5.04
                c4.78-6.28,7.66-14.13,7.66-22.66c0-8.4-2.79-16.12-7.43-22.35L102.13,10.13z"/>
            </g>
            <path style="fill:current-color" d="M112.07,0c5.89,7.53,9.42,17.06,9.42,27.39c0,10.51-3.64,20.15-9.68,27.72v0.04h54.27V0H112.07z"/>
          </g>
          <g>
            <g>
              <path style="fill:current-color" d="M0,6.98v5.17h11.17v30.56h6V12.15h11.2V6.98H0z"/>
              <path style="fill:current-color" d="M50.67,37.8c-0.22,0.18-0.47,0.36-0.87,0.36c-0.94,0-1.24-0.95-1.24-2.44V25.14
                c0-7.93-6.66-10.59-12.48-10.59c-4.66,0-8.4,1.71-11.31,4.58l3.42,3.27c1.89-1.86,4.26-3.16,7.35-3.16
                c3.71,0,7.24,1.93,7.24,5.89v1.53c-1.93-0.73-4.22-1.27-7.13-1.27c-6.66,0-12.08,2.8-12.08,8.91c0,5.93,5.17,9.06,10.73,9.06
                c3.56,0,6.91-1.31,9.24-3.56c0.69,2.26,2.47,3.56,4.91,3.56c1.34,0,2.51-0.36,3.24-0.95L50.67,37.8z M42.78,32.77
                c0,3.82-3.56,6.18-7.31,6.18c-3.06,0-6-1.53-6-4.66c0-2.98,2.66-4.84,6.95-4.84c2.62,0,4.95,0.73,6.37,1.27V32.77z"/>
              <path style="fill:current-color" d="M70.39,14.55c-3.82,0-7.02,1.6-9.42,4.04c-0.58-2.55-2.4-4.04-4.95-4.04c-1.53,0-2.62,0.4-3.38,0.95
                l1.06,4.62c0.22-0.15,0.47-0.33,0.87-0.33c1.02,0,1.24,0.95,1.24,2.4v28.77h5.89V40.01c2.25,2.04,5.24,3.35,8.69,3.35
                c8.22,0,13.75-6.37,13.75-14.4C84.14,20.95,78.61,14.55,70.39,14.55z M69.7,38.16c-4.77,0-8.55-3.2-8.55-9.2
                c0-5.97,3.78-9.17,8.55-9.17c5.02,0,8.44,4.11,8.44,9.17C78.13,34.08,74.71,38.16,69.7,38.16z"/>
            </g>
          </g>
        </g>
        </svg>

      <p class="tag-square-message-top">Add Message</p>
      <img src="" class="tag-square-image"/>

      <svg width="60%" viewBox="0 0 318.94 35.25">
        <g>
          <path style="fill:currentcolor" d="M14.65,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88H0V9.3h2.96V4.63h5.56V9.3h4.78v4.28H8.52
            v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L14.65,27.13z"/>
          <path style="fill:currentcolor" d="M34.75,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C31.36,8.59,34.75,11.3,34.75,17.11z M29.19,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C26.94,24.6,28.55,23.74,29.19,21.99z"/>
          <path style="fill:currentcolor" d="M60.66,18.46c0,6.02-4.17,9.87-9.55,9.87c-2.39,0-4.35-0.75-5.77-2.32v8.95h-5.56V8.88h5.31v2.21
            c1.39-1.68,3.46-2.5,6.02-2.5C56.49,8.59,60.66,12.44,60.66,18.46z M55.03,18.46c0-3.32-2.1-5.31-4.88-5.31s-4.88,2-4.88,5.31
            c0,3.31,2.1,5.31,4.88,5.31S55.03,21.78,55.03,18.46z"/>
          <path style="fill:currentcolor" d="M76.73,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            H70.6v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L76.73,27.13z"/>
          <path style="fill:currentcolor" d="M79.19,3.1c0-1.75,1.39-3.1,3.46-3.1s3.46,1.28,3.46,2.99c0,1.85-1.39,3.21-3.46,3.21S79.19,4.85,79.19,3.1z M79.87,8.88
            h5.56v19.18h-5.56V8.88z"/>
          <path style="fill:currentcolor" d="M109.63,8.88l-8.09,19.18H95.8L87.74,8.88h5.74l5.31,13.05l5.49-13.05H109.63z"/>
          <path style="fill:currentcolor" d="M128.23,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C124.84,8.59,128.23,11.3,128.23,17.11z M122.67,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C120.42,24.6,122.03,23.74,122.67,21.99z"/>
          <path style="fill:currentcolor" d="M145.62,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            h-4.78v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L145.62,27.13z"/>
          <path style="fill:currentcolor" d="M166.83,20.03h-14.51c0.53,2.39,2.57,3.85,5.49,3.85c2.03,0,3.49-0.61,4.81-1.85l2.96,3.21c-1.78,2.03-4.46,3.1-7.91,3.1
            c-6.63,0-10.94-4.17-10.94-9.87c0-5.74,4.38-9.87,10.23-9.87c5.63,0,9.98,3.78,9.98,9.94C166.93,18.96,166.86,19.57,166.83,20.03z
             M152.25,16.79h9.45c-0.39-2.42-2.21-3.99-4.71-3.99C154.46,12.8,152.64,14.33,152.25,16.79z"/>
          <path style="fill:currentcolor" d="M183.01,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            h-4.78v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L183.01,27.13z"/>
          <path style="fill:currentcolor" d="M203.11,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C199.72,8.59,203.11,11.3,203.11,17.11z M197.55,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C195.3,24.6,196.9,23.74,197.55,21.99z"/>
          <path style="fill:currentcolor" d="M228.13,8.88v15.97c0,7.13-3.85,10.41-10.76,10.41c-3.64,0-7.16-0.89-9.41-2.64l2.21-3.99c1.64,1.32,4.31,2.17,6.77,2.17
            c3.92,0,5.63-1.78,5.63-5.24v-0.82c-1.46,1.6-3.56,2.39-6.06,2.39c-5.31,0-9.59-3.67-9.59-9.27s4.28-9.27,9.59-9.27
            c2.67,0,4.88,0.89,6.34,2.75V8.88H228.13z M222.64,17.86c0-2.82-2.1-4.71-5.03-4.71s-5.06,1.89-5.06,4.71s2.14,4.71,5.06,4.71
            S222.64,20.67,222.64,17.86z"/>
          <path style="fill:currentcolor" d="M231.94,24.84c0-2.07,1.53-3.42,3.46-3.42s3.46,1.35,3.46,3.42c0,2.03-1.53,3.49-3.46,3.49S231.94,26.88,231.94,24.84z"/>
          <path style="fill:currentcolor" d="M240.95,18.46c0-5.78,4.46-9.87,10.69-9.87c4.03,0,7.2,1.75,8.59,4.88l-4.31,2.32c-1.03-1.82-2.57-2.64-4.31-2.64
            c-2.82,0-5.03,1.96-5.03,5.31c0,3.35,2.21,5.31,5.03,5.31c1.75,0,3.28-0.78,4.31-2.64l4.31,2.35c-1.39,3.07-4.56,4.85-8.59,4.85
            C245.41,28.34,240.95,24.24,240.95,18.46z"/>
          <path style="fill:currentcolor" d="M261.77,18.46c0-5.78,4.46-9.87,10.55-9.87s10.52,4.1,10.52,9.87c0,5.77-4.42,9.87-10.52,9.87S261.77,24.24,261.77,18.46z
             M277.2,18.46c0-3.32-2.1-5.31-4.88-5.31s-4.92,2-4.92,5.31c0,3.31,2.14,5.31,4.92,5.31S277.2,21.78,277.2,18.46z"/>
          <path style="fill:currentcolor" d="M318.94,17.07v10.98h-5.56V17.93c0-3.1-1.39-4.53-3.64-4.53c-2.5,0-4.24,1.6-4.24,5.03v9.62h-5.56V17.93
            c0-3.1-1.32-4.53-3.64-4.53c-2.46,0-4.21,1.6-4.21,5.03v9.62h-5.56V8.88h5.31v2.21c1.43-1.64,3.56-2.5,6.02-2.5
            c2.67,0,4.95,1.03,6.31,3.14c1.53-1.96,4.03-3.14,6.92-3.14C315.66,8.59,318.94,11.23,318.94,17.07z"/>
        </g>
      </svg>

    </div>
  `
};
const rectH = {
  css: `
    .tag-recth {
      box-sizing: border-box;
      width: 100%;
      height: 62.79%;
      overflow: hidden;
      padding: 6% 0 0 0;
      background-color: #ffffff;
      background-position: center center;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      text-align: center;
    }
    .tag-recth-image {
      width: 80%;
      height: 30%;
      object-fit: contain;
    }
    .tag-recth-message {
      padding: 4%;
      font-family: sans-serif;
    }
  `,
  html: `
    <div class="tag-recth">
      <svg width="40%" viewBox="0 0 166.09 55.15">
        <g>
          <g>
            <g>
              <path style="fill:current-color" d="M91.99,20.44c1.03,2.12,1.67,4.48,1.67,7c0,2.67-0.71,5.14-1.86,7.35l5.12,5.2c2.33-3.61,3.7-7.92,3.7-12.55
                c0-4.49-1.29-8.67-3.49-12.21L91.99,20.44z"/>
            </g>
            <g>
              <path style="fill:current-color" d="M102.13,10.13c3.41,4.9,5.44,10.86,5.44,17.31c0,6.59-2.12,12.66-5.67,17.62l4.96,5.04
                c4.78-6.28,7.66-14.13,7.66-22.66c0-8.4-2.79-16.12-7.43-22.35L102.13,10.13z"/>
            </g>
            <path style="fill:current-color" d="M112.07,0c5.89,7.53,9.42,17.06,9.42,27.39c0,10.51-3.64,20.15-9.68,27.72v0.04h54.27V0H112.07z"/>
          </g>
          <g>
            <g>
              <path style="fill:current-color" d="M0,6.98v5.17h11.17v30.56h6V12.15h11.2V6.98H0z"/>
              <path style="fill:current-color" d="M50.67,37.8c-0.22,0.18-0.47,0.36-0.87,0.36c-0.94,0-1.24-0.95-1.24-2.44V25.14
                c0-7.93-6.66-10.59-12.48-10.59c-4.66,0-8.4,1.71-11.31,4.58l3.42,3.27c1.89-1.86,4.26-3.16,7.35-3.16
                c3.71,0,7.24,1.93,7.24,5.89v1.53c-1.93-0.73-4.22-1.27-7.13-1.27c-6.66,0-12.08,2.8-12.08,8.91c0,5.93,5.17,9.06,10.73,9.06
                c3.56,0,6.91-1.31,9.24-3.56c0.69,2.26,2.47,3.56,4.91,3.56c1.34,0,2.51-0.36,3.24-0.95L50.67,37.8z M42.78,32.77
                c0,3.82-3.56,6.18-7.31,6.18c-3.06,0-6-1.53-6-4.66c0-2.98,2.66-4.84,6.95-4.84c2.62,0,4.95,0.73,6.37,1.27V32.77z"/>
              <path style="fill:current-color" d="M70.39,14.55c-3.82,0-7.02,1.6-9.42,4.04c-0.58-2.55-2.4-4.04-4.95-4.04c-1.53,0-2.62,0.4-3.38,0.95
                l1.06,4.62c0.22-0.15,0.47-0.33,0.87-0.33c1.02,0,1.24,0.95,1.24,2.4v28.77h5.89V40.01c2.25,2.04,5.24,3.35,8.69,3.35
                c8.22,0,13.75-6.37,13.75-14.4C84.14,20.95,78.61,14.55,70.39,14.55z M69.7,38.16c-4.77,0-8.55-3.2-8.55-9.2
                c0-5.97,3.78-9.17,8.55-9.17c5.02,0,8.44,4.11,8.44,9.17C78.13,34.08,74.71,38.16,69.7,38.16z"/>
            </g>
          </g>
        </g>
        </svg>

      <p class="tag-recth-message-top">Add Message</p>
      <img src="" class="tag-recth-image"/>

      <svg width="60%" viewBox="0 0 318.94 35.25">
        <g>
          <path style="fill:currentcolor" d="M14.65,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88H0V9.3h2.96V4.63h5.56V9.3h4.78v4.28H8.52
            v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L14.65,27.13z"/>
          <path style="fill:currentcolor" d="M34.75,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C31.36,8.59,34.75,11.3,34.75,17.11z M29.19,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C26.94,24.6,28.55,23.74,29.19,21.99z"/>
          <path style="fill:currentcolor" d="M60.66,18.46c0,6.02-4.17,9.87-9.55,9.87c-2.39,0-4.35-0.75-5.77-2.32v8.95h-5.56V8.88h5.31v2.21
            c1.39-1.68,3.46-2.5,6.02-2.5C56.49,8.59,60.66,12.44,60.66,18.46z M55.03,18.46c0-3.32-2.1-5.31-4.88-5.31s-4.88,2-4.88,5.31
            c0,3.31,2.1,5.31,4.88,5.31S55.03,21.78,55.03,18.46z"/>
          <path style="fill:currentcolor" d="M76.73,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            H70.6v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L76.73,27.13z"/>
          <path style="fill:currentcolor" d="M79.19,3.1c0-1.75,1.39-3.1,3.46-3.1s3.46,1.28,3.46,2.99c0,1.85-1.39,3.21-3.46,3.21S79.19,4.85,79.19,3.1z M79.87,8.88
            h5.56v19.18h-5.56V8.88z"/>
          <path style="fill:currentcolor" d="M109.63,8.88l-8.09,19.18H95.8L87.74,8.88h5.74l5.31,13.05l5.49-13.05H109.63z"/>
          <path style="fill:currentcolor" d="M128.23,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C124.84,8.59,128.23,11.3,128.23,17.11z M122.67,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C120.42,24.6,122.03,23.74,122.67,21.99z"/>
          <path style="fill:currentcolor" d="M145.62,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            h-4.78v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L145.62,27.13z"/>
          <path style="fill:currentcolor" d="M166.83,20.03h-14.51c0.53,2.39,2.57,3.85,5.49,3.85c2.03,0,3.49-0.61,4.81-1.85l2.96,3.21c-1.78,2.03-4.46,3.1-7.91,3.1
            c-6.63,0-10.94-4.17-10.94-9.87c0-5.74,4.38-9.87,10.23-9.87c5.63,0,9.98,3.78,9.98,9.94C166.93,18.96,166.86,19.57,166.83,20.03z
             M152.25,16.79h9.45c-0.39-2.42-2.21-3.99-4.71-3.99C154.46,12.8,152.64,14.33,152.25,16.79z"/>
          <path style="fill:currentcolor" d="M183.01,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            h-4.78v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L183.01,27.13z"/>
          <path style="fill:currentcolor" d="M203.11,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C199.72,8.59,203.11,11.3,203.11,17.11z M197.55,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C195.3,24.6,196.9,23.74,197.55,21.99z"/>
          <path style="fill:currentcolor" d="M228.13,8.88v15.97c0,7.13-3.85,10.41-10.76,10.41c-3.64,0-7.16-0.89-9.41-2.64l2.21-3.99c1.64,1.32,4.31,2.17,6.77,2.17
            c3.92,0,5.63-1.78,5.63-5.24v-0.82c-1.46,1.6-3.56,2.39-6.06,2.39c-5.31,0-9.59-3.67-9.59-9.27s4.28-9.27,9.59-9.27
            c2.67,0,4.88,0.89,6.34,2.75V8.88H228.13z M222.64,17.86c0-2.82-2.1-4.71-5.03-4.71s-5.06,1.89-5.06,4.71s2.14,4.71,5.06,4.71
            S222.64,20.67,222.64,17.86z"/>
          <path style="fill:currentcolor" d="M231.94,24.84c0-2.07,1.53-3.42,3.46-3.42s3.46,1.35,3.46,3.42c0,2.03-1.53,3.49-3.46,3.49S231.94,26.88,231.94,24.84z"/>
          <path style="fill:currentcolor" d="M240.95,18.46c0-5.78,4.46-9.87,10.69-9.87c4.03,0,7.2,1.75,8.59,4.88l-4.31,2.32c-1.03-1.82-2.57-2.64-4.31-2.64
            c-2.82,0-5.03,1.96-5.03,5.31c0,3.35,2.21,5.31,5.03,5.31c1.75,0,3.28-0.78,4.31-2.64l4.31,2.35c-1.39,3.07-4.56,4.85-8.59,4.85
            C245.41,28.34,240.95,24.24,240.95,18.46z"/>
          <path style="fill:currentcolor" d="M261.77,18.46c0-5.78,4.46-9.87,10.55-9.87s10.52,4.1,10.52,9.87c0,5.77-4.42,9.87-10.52,9.87S261.77,24.24,261.77,18.46z
             M277.2,18.46c0-3.32-2.1-5.31-4.88-5.31s-4.92,2-4.92,5.31c0,3.31,2.14,5.31,4.92,5.31S277.2,21.78,277.2,18.46z"/>
          <path style="fill:currentcolor" d="M318.94,17.07v10.98h-5.56V17.93c0-3.1-1.39-4.53-3.64-4.53c-2.5,0-4.24,1.6-4.24,5.03v9.62h-5.56V17.93
            c0-3.1-1.32-4.53-3.64-4.53c-2.46,0-4.21,1.6-4.21,5.03v9.62h-5.56V8.88h5.31v2.21c1.43-1.64,3.56-2.5,6.02-2.5
            c2.67,0,4.95,1.03,6.31,3.14c1.53-1.96,4.03-3.14,6.92-3.14C315.66,8.59,318.94,11.23,318.94,17.07z"/>
        </g>
      </svg>

    </div>
  `
};
const rectV = {
  css: `
    .tag-rectv {
      box-sizing: border-box;
      width: 62.79%;
      height: 100%;
      overflow: hidden;
      padding: 6% 0 0 0;
      background-color: #ffffff;
      background-position: center center;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      text-align: center;
    }
    .tag-rectv-image {
      width: 80%;
      height: 30%;
      object-fit: contain;
    }
    .tag-rectv-message {
      padding: 4%;
      font-family: sans-serif;
    }
  `,
  html: `
    <div class="tag-rectv">
      <svg width="40%" viewBox="0 0 166.09 55.15">
        <g>
          <g>
            <g>
              <path style="fill:current-color" d="M91.99,20.44c1.03,2.12,1.67,4.48,1.67,7c0,2.67-0.71,5.14-1.86,7.35l5.12,5.2c2.33-3.61,3.7-7.92,3.7-12.55
                c0-4.49-1.29-8.67-3.49-12.21L91.99,20.44z"/>
            </g>
            <g>
              <path style="fill:current-color" d="M102.13,10.13c3.41,4.9,5.44,10.86,5.44,17.31c0,6.59-2.12,12.66-5.67,17.62l4.96,5.04
                c4.78-6.28,7.66-14.13,7.66-22.66c0-8.4-2.79-16.12-7.43-22.35L102.13,10.13z"/>
            </g>
            <path style="fill:current-color" d="M112.07,0c5.89,7.53,9.42,17.06,9.42,27.39c0,10.51-3.64,20.15-9.68,27.72v0.04h54.27V0H112.07z"/>
          </g>
          <g>
            <g>
              <path style="fill:current-color" d="M0,6.98v5.17h11.17v30.56h6V12.15h11.2V6.98H0z"/>
              <path style="fill:current-color" d="M50.67,37.8c-0.22,0.18-0.47,0.36-0.87,0.36c-0.94,0-1.24-0.95-1.24-2.44V25.14
                c0-7.93-6.66-10.59-12.48-10.59c-4.66,0-8.4,1.71-11.31,4.58l3.42,3.27c1.89-1.86,4.26-3.16,7.35-3.16
                c3.71,0,7.24,1.93,7.24,5.89v1.53c-1.93-0.73-4.22-1.27-7.13-1.27c-6.66,0-12.08,2.8-12.08,8.91c0,5.93,5.17,9.06,10.73,9.06
                c3.56,0,6.91-1.31,9.24-3.56c0.69,2.26,2.47,3.56,4.91,3.56c1.34,0,2.51-0.36,3.24-0.95L50.67,37.8z M42.78,32.77
                c0,3.82-3.56,6.18-7.31,6.18c-3.06,0-6-1.53-6-4.66c0-2.98,2.66-4.84,6.95-4.84c2.62,0,4.95,0.73,6.37,1.27V32.77z"/>
              <path style="fill:current-color" d="M70.39,14.55c-3.82,0-7.02,1.6-9.42,4.04c-0.58-2.55-2.4-4.04-4.95-4.04c-1.53,0-2.62,0.4-3.38,0.95
                l1.06,4.62c0.22-0.15,0.47-0.33,0.87-0.33c1.02,0,1.24,0.95,1.24,2.4v28.77h5.89V40.01c2.25,2.04,5.24,3.35,8.69,3.35
                c8.22,0,13.75-6.37,13.75-14.4C84.14,20.95,78.61,14.55,70.39,14.55z M69.7,38.16c-4.77,0-8.55-3.2-8.55-9.2
                c0-5.97,3.78-9.17,8.55-9.17c5.02,0,8.44,4.11,8.44,9.17C78.13,34.08,74.71,38.16,69.7,38.16z"/>
            </g>
          </g>
        </g>
        </svg>

      <p class="tag-rectv-message-top">Add Message</p>
      <img src="" class="tag-rectv-image"/>

      <svg width="60%" viewBox="0 0 318.94 35.25">
        <g>
          <path style="fill:currentcolor" d="M14.65,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88H0V9.3h2.96V4.63h5.56V9.3h4.78v4.28H8.52
            v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L14.65,27.13z"/>
          <path style="fill:currentcolor" d="M34.75,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C31.36,8.59,34.75,11.3,34.75,17.11z M29.19,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C26.94,24.6,28.55,23.74,29.19,21.99z"/>
          <path style="fill:currentcolor" d="M60.66,18.46c0,6.02-4.17,9.87-9.55,9.87c-2.39,0-4.35-0.75-5.77-2.32v8.95h-5.56V8.88h5.31v2.21
            c1.39-1.68,3.46-2.5,6.02-2.5C56.49,8.59,60.66,12.44,60.66,18.46z M55.03,18.46c0-3.32-2.1-5.31-4.88-5.31s-4.88,2-4.88,5.31
            c0,3.31,2.1,5.31,4.88,5.31S55.03,21.78,55.03,18.46z"/>
          <path style="fill:currentcolor" d="M76.73,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            H70.6v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L76.73,27.13z"/>
          <path style="fill:currentcolor" d="M79.19,3.1c0-1.75,1.39-3.1,3.46-3.1s3.46,1.28,3.46,2.99c0,1.85-1.39,3.21-3.46,3.21S79.19,4.85,79.19,3.1z M79.87,8.88
            h5.56v19.18h-5.56V8.88z"/>
          <path style="fill:currentcolor" d="M109.63,8.88l-8.09,19.18H95.8L87.74,8.88h5.74l5.31,13.05l5.49-13.05H109.63z"/>
          <path style="fill:currentcolor" d="M128.23,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C124.84,8.59,128.23,11.3,128.23,17.11z M122.67,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C120.42,24.6,122.03,23.74,122.67,21.99z"/>
          <path style="fill:currentcolor" d="M145.62,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            h-4.78v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L145.62,27.13z"/>
          <path style="fill:currentcolor" d="M166.83,20.03h-14.51c0.53,2.39,2.57,3.85,5.49,3.85c2.03,0,3.49-0.61,4.81-1.85l2.96,3.21c-1.78,2.03-4.46,3.1-7.91,3.1
            c-6.63,0-10.94-4.17-10.94-9.87c0-5.74,4.38-9.87,10.23-9.87c5.63,0,9.98,3.78,9.98,9.94C166.93,18.96,166.86,19.57,166.83,20.03z
             M152.25,16.79h9.45c-0.39-2.42-2.21-3.99-4.71-3.99C154.46,12.8,152.64,14.33,152.25,16.79z"/>
          <path style="fill:currentcolor" d="M183.01,27.13c-1.14,0.82-2.82,1.21-4.53,1.21c-4.53,0-7.16-2.32-7.16-6.88v-7.88h-2.96V9.3h2.96V4.63h5.56V9.3h4.78v4.28
            h-4.78v7.81c0,1.64,0.89,2.53,2.39,2.53c0.82,0,1.64-0.25,2.25-0.71L183.01,27.13z"/>
          <path style="fill:currentcolor" d="M203.11,17.11v10.94h-5.2v-2.39c-1.03,1.75-3.03,2.67-5.85,2.67c-4.49,0-7.16-2.5-7.16-5.81c0-3.39,2.39-5.74,8.23-5.74
            h4.42c0-2.39-1.43-3.78-4.42-3.78c-2.03,0-4.13,0.68-5.52,1.78l-2-3.88c2.1-1.5,5.2-2.32,8.27-2.32
            C199.72,8.59,203.11,11.3,203.11,17.11z M197.55,21.99v-1.96h-3.81c-2.6,0-3.42,0.96-3.42,2.25c0,1.39,1.18,2.32,3.14,2.32
            C195.3,24.6,196.9,23.74,197.55,21.99z"/>
          <path style="fill:currentcolor" d="M228.13,8.88v15.97c0,7.13-3.85,10.41-10.76,10.41c-3.64,0-7.16-0.89-9.41-2.64l2.21-3.99c1.64,1.32,4.31,2.17,6.77,2.17
            c3.92,0,5.63-1.78,5.63-5.24v-0.82c-1.46,1.6-3.56,2.39-6.06,2.39c-5.31,0-9.59-3.67-9.59-9.27s4.28-9.27,9.59-9.27
            c2.67,0,4.88,0.89,6.34,2.75V8.88H228.13z M222.64,17.86c0-2.82-2.1-4.71-5.03-4.71s-5.06,1.89-5.06,4.71s2.14,4.71,5.06,4.71
            S222.64,20.67,222.64,17.86z"/>
          <path style="fill:currentcolor" d="M231.94,24.84c0-2.07,1.53-3.42,3.46-3.42s3.46,1.35,3.46,3.42c0,2.03-1.53,3.49-3.46,3.49S231.94,26.88,231.94,24.84z"/>
          <path style="fill:currentcolor" d="M240.95,18.46c0-5.78,4.46-9.87,10.69-9.87c4.03,0,7.2,1.75,8.59,4.88l-4.31,2.32c-1.03-1.82-2.57-2.64-4.31-2.64
            c-2.82,0-5.03,1.96-5.03,5.31c0,3.35,2.21,5.31,5.03,5.31c1.75,0,3.28-0.78,4.31-2.64l4.31,2.35c-1.39,3.07-4.56,4.85-8.59,4.85
            C245.41,28.34,240.95,24.24,240.95,18.46z"/>
          <path style="fill:currentcolor" d="M261.77,18.46c0-5.78,4.46-9.87,10.55-9.87s10.52,4.1,10.52,9.87c0,5.77-4.42,9.87-10.52,9.87S261.77,24.24,261.77,18.46z
             M277.2,18.46c0-3.32-2.1-5.31-4.88-5.31s-4.92,2-4.92,5.31c0,3.31,2.14,5.31,4.92,5.31S277.2,21.78,277.2,18.46z"/>
          <path style="fill:currentcolor" d="M318.94,17.07v10.98h-5.56V17.93c0-3.1-1.39-4.53-3.64-4.53c-2.5,0-4.24,1.6-4.24,5.03v9.62h-5.56V17.93
            c0-3.1-1.32-4.53-3.64-4.53c-2.46,0-4.21,1.6-4.21,5.03v9.62h-5.56V8.88h5.31v2.21c1.43-1.64,3.56-2.5,6.02-2.5
            c2.67,0,4.95,1.03,6.31,3.14c1.53-1.96,4.03-3.14,6.92-3.14C315.66,8.59,318.94,11.23,318.94,17.07z"/>
        </g>
      </svg>

    </div>
  `
};

export default {
  // round
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY1ODU0OA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzY5MTMxNg==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTE0MDg4NzYyNTc4MA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc5ODU4MA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTc2NTgxMg==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNTczMzA0NA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA3NjUzMg==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzA0Mzc2NA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQzNzAxMDk5Ng==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NzkzNTM2NA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2Nzk2ODEzMg==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODAwMDkwMA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ1OTY1Mg==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODQ5MjQyMA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODUyNTE4OA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDYyMDAzNg==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDY1MjgwNA==": round,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDcxODM0MA==": round,
  
  // square 
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MTc2NDUzMg==": square,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU1MjA1OTQ0NA==": square,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTQ1MjY3NDEwMA==": square,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NTkzNjUxNg==": square,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2NjQ2MDgwNA==": square,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3NDA5NTc0OA==": square,
  
  // rectangle H
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUwMTY2MjI2MA==": rectH,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNzE4Mjc3Mg==": rectH,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzODM5NTE4OA==": rectH,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MTkwMDI5Mg==": rectH,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MjQ5MDExNg==": rectH,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzgwMDgzNg==": rectH,
  
  // rectangle V
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTUzNDY5MjQwNA==": rectV,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTAxNjYyOA==": rectV,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMTIxOTU0MTYwNjQ1Mg==": rectV,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA2ODg4NTYzNg==": rectV,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MDE5NjM1Ng==": rectV,
  "Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zMjM5NDA3MzExMjcwOA==": rectV,
};